import React,  { useState, useEffect }  from "react";
import moment from "moment";
import IframeResizer from "iframe-resizer-react";
import { SignalCellularNoSimOutlined } from "@material-ui/icons";
import ScaleLoader from "react-spinners/ScaleLoader";


// custom reports   //
export const PlaysByStreamType = (props) => (
  <BaseWidget
    {...props}
    title="Video Plays By Type"
    module="CustomReports"
    action="getCustomReport"
    opts="&idCustomReport=4&filter_limit=5"
  />
);

export const PlaysByEventType = (props) => (
  <BaseWidget
    {...props}
    title="Video Plays By Event"
    module="CustomReports"
    action="getCustomReport"
    opts="&idCustomReport=6&filter_limit=5"
  />
);

export const VideoDownloads = (props) => (
    <BaseWidget
        {...props}
        title="Video Downloads"
        module="CustomReports"
        action="getCustomReport"
        opts="&idCustomReport=25&filter_limit=5"
        eventViewOnly={true}
    />
);

// audio downloads
export const AudioDownloads = (props) => (
    <BaseWidget
        {...props}
        title="Audio Downloads"
        module="CustomReports"
        action="getCustomReport"
        opts="&idCustomReport=26&filter_limit=5"
        eventViewOnly={true}
    />
);

export const TopCity = (props) => (
  <BaseWidget
    {...props}
    title="Top Cities"
    module="CustomReports"
    action="getCustomReport"
    opts="&idCustomReport=10&filter_limit=5"
  />
);

export const TopCountry = (props) => (
  <BaseWidget
    {...props}
    title="Top Country"
    module="CustomReports"
    action="getCustomReport"
    opts="&idCustomReport=11&filter_limit=5"
  />
);
export const TopBrowsers = (props) => (
  <BaseWidget
    {...props}
    title="Top Browsers"
    module="CustomReports"
    action="getCustomReport"
    opts="&idCustomReport=8&forceView=1&viewDataTable=graphPie&filter_limit=5"
  />
);

export const TopRefferrer = (props) => (
  <BaseWidget
    {...props}
    title="Top Referrers"
    module="CustomReports"
    action="getCustomReport"
    opts="&idCustomReport=9&forceView=1&viewDataTable=graphPie&filter_limit=5"
  />
);

export const TopDevices = (props) => (
  <BaseWidget
    {...props}
    title="Top Devices"
    module="CustomReports"
    action="getCustomReport"
    opts="&idCustomReport=13&forceView=1&viewDataTable=graphPie&filter_limit=5"
  />
);

export const TopOS = (props) => (
  <BaseWidget
    {...props}
    title="Top OS"
    module="CustomReports"
    action="getCustomReport"
    opts="&idCustomReport=14&forceView=1&viewDataTable=graphVerticalBar&filter_limit=5"
  />
);

export const TopPlatform = (props) => (
  <BaseWidget
    {...props}
    title="Top Platform"
    module="CustomReports"
    action="getCustomReport"
    opts="&idCustomReport=12&forceView=1&viewDataTable=graphVerticalBar&filter_limit=5"
  />
);

export const MediaReport = (props) => (
  <BaseWidget
    {...props}
    title="Overview"
    module="MediaAnalytics"
    action="get"
    opts="&forceView=1&viewDataTable=sparklines"
  />
);

export const MediaEvolution = (props) => (
  <BaseWidget
    {...props}
    title="Play Evolution"
    module="MediaAnalytics"
    action="getEvolutionGraph"
    opts="&forceView=1&viewDataTable=graphEvolution&columns[]=nb_plays"
  />
);

export const SocialNetworks = (props) => (
  <BaseWidget
    {...props}
    title="Social Referrers"
    module="Referrers"
    action="getSocials"
    opts="&forceView=1&viewDataTable=graphPie&filter_limit=5"
  />
);

export const SearchEngines = (props) => (
  <BaseWidget
    {...props}
    title="Search Engines"
    module="Referrers"
    action="getSearchEngines"
    opts="&forceView=1&viewDataTable=graphPie&filter_limit=5"
  />
);

/**
 * @deprecated
 */
export const VideoTitles = (props) => (
  <BaseWidget
    {...props}
    title="Video Titles"
    module="MediaAnalytics"
    action="getVideoTitles"
  />
);

export const VideoRealtimeMap = (props) => (
  <BaseWidget
    {...props}
    title="Viewer Locations"
    module="MediaAnalytics"
    action="realTimeAudienceMap"
  />
);

/**
 * Pick the Matomo `period`/`date` params for a selected [start, end] window.
 *
 * Matomo only pre-archives `day`/`week`/`month`/`year` periods (via the cron
 * archiver). `range` periods are archived on-demand at request time and, for
 * high-volume sites (e.g. TVW), silently return an empty archive once the
 * window is wide enough -- the CustomReports widgets then render "no data"
 * while the lighter MediaAnalytics Overview still works. See analytics
 * investigation: only the largest client (site 7 / clientID 9375922947)
 * blew the on-demand range-archive ceiling at ~30 days.
 *
 * When the window aligns exactly to a single calendar month or year, request
 * that pre-archived period instead so big sites render. A single day maps to
 * `period=day`. Everything else (weeks, quarters, arbitrary spans) stays on
 * `range` -- those either stay small enough to archive on-demand (weeks) or
 * still depend on server-side range archiving being enabled (quarters).
 *
 * Week is intentionally NOT snapped: moment's locale week (Sun-Sat) and
 * Matomo's week (Mon-Sun) disagree on boundaries, so snapping would shift the
 * reported window by a day. 7-day ranges archive fine on-demand regardless.
 */
function resolvePeriodParam(startDate, endDate) {
  const start = moment(startDate);
  const end = moment(endDate);
  const spans = (unit) =>
    start.isSame(start.clone().startOf(unit), "day") &&
    end.isSame(start.clone().endOf(unit), "day");

  if (start.isSame(end, "day")) {
    return "&period=day&date=" + start.format("YYYY-MM-DD");
  }
  if (spans("month")) {
    return "&period=month&date=" + start.format("YYYY-MM-DD");
  }
  if (spans("year")) {
    return "&period=year&date=" + start.format("YYYY-MM-DD");
  }
  return "&period=range&date="
    + start.format("YYYY-MM-DD") + "%2C" + end.format("YYYY-MM-DD");
}

const BaseWidget = (props) => {

  const [oniframload, setOniframload] = useState(false);
  const [iframeURL, setIframeURL] = useState(null);

  var URL = "https://statistics.invintusmedia.com/index.php?module=Widgetize&action=iframe&disableLink=0&widget=1" +
  "&moduleToWidgetize=" +
  props.module +
  "&actionToWidgetize=" +
  props.action +
  "&idSite=" +
  props.siteID +
  "&disableLink=0&widget=1" +
  "&token_auth=cf1ddf39c67e56fa819d757fd76ef8ed";
  if (props.opts) {
    URL += props.opts;
  }
  if (props.event) {
    URL +=
      "&segment=dimension1%3D%3D" +
      props.clientID +
      "_" +
      props.event.eventID;
  }
  if(props.date) {
    URL += resolvePeriodParam(props.date.startDate, props.date.endDate);
  } else {
    URL += "&period=month&date=" + moment().format("YYYY-MM-DD");
  }
  if (URL !== iframeURL) {
    setIframeURL(URL);
    setOniframload(false)
  }

  function loader(){
    if (oniframload == false){
      return (<div className="loader">loading report <ScaleLoader  height={5} width={3} radius={2} margin={2} color={"#333"} loading={true} speedMultiplier={0.5} /></div>)
    } else {
      return ''
    }
  }
  const loaded = () => {
    if (oniframload == false){
      setOniframload(true)
    }
  }

  if (props.eventViewOnly && !props.event) {
    return null;
  }

  return (
    <div
      className="panel panel-default"
      style={{
        display: "inline-block",
        width: "99%",
      }}
    >
      <div className="panel-heading">
        <h3 className="panel-title">{props.title}</h3>
        {!props.aspectFormat ? ( <div>{loader()}</div>
          ) : ''}

      </div>
      <div
        className={`panel-body  ${
          props.aspectFormat && "iframe-container"
        }`}
      >
        {props.aspectFormat ? (
          <iframe className="responsive-iframe" src={URL} />
        ) : (
          <><IframeResizer
              onResized = {(e)=>loaded()}
              checkOrigin={false}
              width="100%"
              src={URL}
              frameBorder="0"
              marginHeight="0"
              marginWidth="0" /></>
        )}
      </div>
    </div>
  );
}
/* class BaseWidget extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    var URL =
      "https://statistics.invintusmedia.com/index.php?module=Widgetize&action=iframe&disableLink=0&widget=1" +
      "&moduleToWidgetize=" +
      this.props.module +
      "&actionToWidgetize=" +
      this.props.action +
      "&idSite=" +
      this.props.siteID +
      "&disableLink=0&widget=1" +
      "&token_auth=cf1ddf39c67e56fa819d757fd76ef8ed";
    if (this.props.opts) {
      URL += this.props.opts;
    }
    if (this.props.event) {
      URL +=
        "&segment=dimension1%3D%3D" +
        this.props.clientID +
        "_" +
        this.props.event.eventID;
    }
    if(this.props.date) {
      URL += "&period=range&date="
      + moment(this.props.date.startDate).format("YYYY-MM-DD") +
      "%2C"
      + moment(this.props.date.endDate).format("YYYY-MM-DD")
    } else {
      URL += "&period=month&date=" + moment().format("YYYY-MM-DD");
    }

    function loader(){
      if (!oniframload) {
        return (<div className="loader">loading stuff</div>)
      } else {
        return ''
      }
    }
    return (
      <div
        className="panel panel-default"
        style={{
          display: "inline-block",
          width: "99%",
        }}
      >
        <div className="panel-heading">
          <h3 className="panel-title">{this.props.title}</h3>
        </div>
        <div
          className={`panel-body  ${
            this.props.aspectFormat && "iframe-container"
          }`}
        >
          {this.props.aspectFormat ? (
            <iframe className="responsive-iframe" src={URL} />
          ) : (
            <><div>{loader()}</div><IframeResizer
                onInit={(e) => setOniframload(e)}
                checkOrigin={false}
                width="100%"
                src={URL}
                frameBorder="0"
                marginHeight="0"
                marginWidth="0" /></>
          )}
        </div>
      </div>
    );
  }
} */
